import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { ConfigService } from 'src/app/shared/config';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    constructor(private firestore: AngularFirestore, private config: ConfigService) {

    }

    // Create a new subscription
    createCategorySubscription(subscriptionData: any): Promise<any> {
        return this.firestore.collection('kampanjeCategorySubscriptions').add(subscriptionData);
    }

    // Get all subscriptions
    getCategorySubscriptions(): Observable<any[]> {
        return this.firestore.collection('kampanjeCategorySubscriptions', ref => ref.where('companyId', '==', this.config.getCompanyId())).snapshotChanges();
    }

    // Update a subscription
    updateCategorySubscription(id: string, subscriptionData: any): Promise<void> {
        if (id)
            return this.firestore.collection('kampanjeCategorySubscriptions').doc(id).update(subscriptionData);
        else 
           return this.createCategorySubscription(subscriptionData);
    }

    checkDuplicateSubscription(subscriptionData: any): Observable<any[]> {
        const { companyId, startTime, endTime, selectedDays, systems } = subscriptionData;
        return this.firestore.collection('kampanjeCategorySubscriptions', ref =>
            ref.where('companyId', '==', companyId)
                .where('selectedDays', '==', selectedDays)
                .where('systems', 'array-contains-any', systems)
        ).snapshotChanges();
    }

    // Delete a subscription
    deleteCategorySubscription(id: string): Promise<void> {
        return this.firestore.collection('kampanjeCategorySubscriptions').doc(id).delete();
    }

    getCategorySubscriptionsById(): Observable<any[]> {
        return this.firestore.collection('kampanjeCategorySubscriptions', ref => ref.where('companyId', "==", this.config.getCompanyId())).snapshotChanges();
    }

    // Get all systems
    getSystems(): Observable<any[]> {
        return this.firestore.collection('system_info', ref => ref.where("companyId", "==", this.config.getCompanyId())).snapshotChanges().pipe(map(docs => {
            return docs.map(doc => {
                const d = doc.payload.doc.data() as any;
                return {
                    ...d,
                    id: doc.payload.doc.id,
                    systemId: doc.payload.doc.id,
                    systemName: d.name || doc.payload.doc.id,
                };
            });
        }));
    }

    getCompanies(): Observable<any[]> {
        return this.firestore.collection('company').snapshotChanges();
    }

    // Get all categories
    getCategories(): Observable<any[]> {
        return this.firestore.collection('company').doc(this.config.getCompanyId()).collection('categories').snapshotChanges();
    }

    // Get all products (one-off read; only what the product picker shows).
    getProducts(): Observable<any[]> {
        return this.firestore.collection('company').doc(this.config.getCompanyId()).collection('products').get().pipe(map(sp => {
            return sp.docs.map(doc => {
                const d = doc.data() as any;
                return { id: doc.id, name: d.name || doc.id, price: d.price, productNumber: d.productNumber };
            });
        }));
    }


}